import React, { FC, memo, ReactElement, useCallback, useState } from 'react';
import { ProjectT } from "../../../../models/models";
import { Span } from '../../../../components/Text/Text';
import ProjectListItemShort from '../ProjectListItemShort/ProjectListItemShort';
import { useWindowResize } from '../../../../utils/hooks/useWindowResize';

import styles from "../../projects.module.scss";

type ProjectItemListPropTypes = {
    items: ProjectT[];
    isFetching: boolean;
    refetch: () => void;
    /** Pagination row rendered after the list, in normal flow (no longer injected into a virtualized
     *  list). The page decides its contents/placement. */
    paginationElement?: ReactElement;
};

// Plain (non-virtualized) list: each page loads at most `take` rows (server-paginated, ≤100), so the
// rows render in normal document flow and the page's `main` scrolls through them — which lets the
// content + pagination + footer reveal at the end of the scroll.
const ProjectItemList: FC<ProjectItemListPropTypes> = memo((props) => {
    const { items = [], isFetching, paginationElement } = props;
    const [showContextMenuIndex, setShowContextMenuIndex] = useState(-1);
    const [windowWidth] = useWindowResize();
    const noop = useCallback(() => {}, []);

    if (!isFetching && !items?.length) {
        return <Span className={styles.noResultsMessage}>There are no campaigns available</Span>;
    }

    return (
        <>
            <ul className={styles.projectList}>
                {items.map((item, index) => (
                    <ProjectListItemShort
                        key={item.Id}
                        project={item}
                        index={index}
                        paginationElement={null}
                        isLastItem={false}
                        showContextMenuIndex={showContextMenuIndex}
                        setShowContextMenuIndex={setShowContextMenuIndex}
                        setSize={noop}
                        windowWidth={windowWidth}
                    />
                ))}
            </ul>
            {paginationElement}
        </>
    );
});

export default ProjectItemList;
